import Banner from './components/banner';
import Team from './components/team';
import Contact from './components/contact';
import Footer from './components/footer';
import WhatWeOffer from './components/whatWeOffer';
import './homeStyles.scss';

import Nav from '../../components/navbar';
import Partners from './components/partners';

const Home = () => {
    return (
        <div>
            <Nav />
            <Banner />
            <div style={{ width: '100vw', marginBottom: '4vh' }}>
                <WhatWeOffer />
                <Team />
                <Partners />
                <Contact />
                <Footer/>
            </div>
        </div>
    );
};

export default Home;
